import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Spinner
} from 'reactstrap';
import ParticlesAuth from '../AuthenticationInner/ParticlesAuth';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { ToastContainer } from 'react-toastify';
import { signInUser } from '../../slices/SignIn/thunk';

const SignIn = () => {
  const dispatch = useDispatch();
  const [userLogin, setUserLogin] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: userLogin.email,
    },
    validationSchema: Yup.object({
      email: Yup.string().required('Please Enter Your User ID')
    }),
    onSubmit: async (values) => {
      dispatch(signInUser(values, navigate, setLoading));
    },
  });

  document.title = 'Elytra';


  return (
    <ParticlesAuth>
      <div className='auth-page-content'>
        <Container>
          <ToastContainer position='top-center' />
          <Row className='justify-content-center'>
            <Col md={8} lg={6} xl={5}>
              <Card className='login-box'>
                <CardBody className='p-4'>
                  <div className='text-center mt-2'>
                    <h5 className='text-main-color'>Welcome Back !</h5>
                    <p className='text-muted'>Sign in to continue</p>
                  </div>
                  <div className='p-2 mt-4'>

                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action='#'
                      >
                        <div className='mb-3'>
                          <Label htmlFor='email' className='form-label'>
                            User ID
                          </Label>
                          <Input
                            name='email'
                            className='form-control'
                            placeholder='Enter User ID'
                            type='text'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ''}
                            invalid={
                              validation.touched.email && validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type='invalid'>
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className='mt-1'>
                          <Button
                            className='btn bg-secondary w-100 mt-2'
                            type='submit'
                            disabled={loading}
                          >
                            {loading ? (
                              <Spinner size='sm' className='me-2'>
                                Loading...
                              </Spinner>
                            ) : null}
                            Sign In
                          </Button>
                        </div>
                      </Form>
            
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

export default SignIn;
